import sequenceComponentFind from 'lib/sequence/component/children/find'
import { asyncPipeSpread } from 'lib/util'
import initAddress from 'app/_shared/action/address/init'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'
import presetCountry from 'app/_shared/action/address/presetCountry'

const initItemAddress = initAddress(
  { component: 'country' },
  { attribute: 'installedAt' },
)

/**
 * ServiceItem Action Location
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  presetCountry(module),
  initItemAddress(
    displayState('state', 'country'),
    displayHouseNumber('number', 'street'),
  )(module),
)(sequenceComponentFind(component), ...args)
